import { useContext } from 'react';
import { TaskDetailPanelContext } from './context';

export default function useOpenTaskDetailPanel() {
  const panel = useContext(TaskDetailPanelContext);
  if (!panel) throw new Error('useShowTaskDetailPanel must be used within an TaskDetailPanelProvider');

  return panel.open;
}
